import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { CheckboxControl } from "@/Common/Components/Inputs/CheckboxControl";
import { CheckedListControl } from "@/Common/Components/Inputs/CheckedListControl";
import { MultiDateSelector } from "@/Common/Components/Inputs/MultiDateSelector";
import { SearchSettingsFooter } from "@/Common/Components/Settings/SearchSettingsFooter";
import { CheckboxTarget } from "@/Common/Models/UI/Inputs/CheckboxTarget";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { INotesInboxModel } from "@/Portfolio/Models/UI/INotesInboxModel";

import "./NotesSettingsContainer.css";

interface INotesSettingsContainerProps {
    Model: INotesInboxModel;
    onClick?: any;
    id?: string;
    className?: string;
    style?: any;
}

class NotesSettingsContainer extends BaseReactComponent<INotesSettingsContainerProps, any> {
    public componentDidMount(): void {
        super.setOverlay("NotesSettingsContainer", { transparent: true });
    }

    public render(): JSX.Element {
        const settingsclass = `${this.props.className} notes-settings filter-component-responsive`;
        return (
            <div
                id={this.props.id}
                className={settingsclass}
                style={this.props.style}
                onClick={this.props.onClick}
                data-cy="settingsContainer"
            >
                <table className="f-content">
                    <thead>
                        <tr>
                            <th>
                                <label className="date-label">{cacheStore.GetString("DateLabel").toUpperCase()}</label>
                            </th>
                            {this.props.Model.get("Sites").count() > 1 && (
                                <th>
                                    <CheckboxControl
                                        id="sites_check"
                                        label={cacheStore.GetString("SitesLabel").toUpperCase()}
                                        operation={LocalOperations.Portfolio.MyNotes_OnSettingsContainerCheckboxChange}
                                        checked={this.props.Model.get("SelectAllSitesChecked")}
                                        target={CheckboxTarget.Myle_Portfolio_MyNotes_SitesControlCheck}
                                    />
                                </th>
                            )}
                            <th>
                                <CheckboxControl
                                    id="clinicians_check"
                                    label={cacheStore.GetString("CliniciansLabel").toUpperCase()}
                                    operation={LocalOperations.Portfolio.MyNotes_OnSettingsContainerCheckboxChange}
                                    checked={this.props.Model.get("SelectAllCliniciansChecked")}
                                    target={CheckboxTarget.Myle_Portfolio_MyNotes_CliniciansControlCheck}
                                />
                            </th>
                            <th>
                                <CheckboxControl
                                    id="status_check"
                                    label={cacheStore.GetString("StatusLabel").toUpperCase()}
                                    operation={LocalOperations.Portfolio.MyNotes_OnSettingsContainerCheckboxChange}
                                    checked={this.props.Model.get("SelectAllStatusChecked")}
                                    target={CheckboxTarget.Myle_Portfolio_MyNotes_StatusControlCheck}
                                />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <MultiDateSelector
                                    id="notes_settings_dateSelector"
                                    fromMyleOperation={LocalOperations.Portfolio.MyNotes_SearchSettings_FromDateChanged}
                                    toMyleOperation={LocalOperations.Portfolio.MyNotes_SearchSettings_ToDateChanged}
                                    fromSetTodayLabel={cacheStore.GetString("TodayLabel")}
                                    toSetTodayLabel={cacheStore.GetString("TodayLabel")}
                                    from={this.props.Model.get("DateFrom")}
                                    to={this.props.Model.get("DateTo")}
                                    dataCy="settings"
                                />
                            </td>
                            {this.props.Model.get("Sites").count() > 1 && (
                                <td className="sites-column">
                                    <div className="sites-control">
                                        <CheckedListControl
                                            DataSource={this.props.Model.get("Sites")}
                                            Operation={LocalOperations.Portfolio.MyNotes_OnSettingsContainerCheckboxChange}
                                            MaxTextLength={25}
                                        />
                                        <CheckboxControl
                                            label={cacheStore.GetString("ShowOnlySelectedSiteLabel").toUpperCase()}
                                            operation={LocalOperations.Portfolio.MyNotes_OnSettingsContainerCheckboxChange}
                                            checked={this.props.Model.get("ShowOnlySelectedSites")}
                                            target={CheckboxTarget.Myle_Portfolio_MyNotes_OnlySelectedSites}
                                            DivWrap
                                        />
                                    </div>
                                </td>
                            )}
                            <td>
                                <input
                                    className="form-control clinicsearch-text"
                                    type="text"
                                    value={this.props.Model.get("CliniciansSearchText")}
                                    onChange={(e: any) => this.onCliniciansFilterTextChanged(e.target.value)}
                                    placeholder={cacheStore.GetString("SearchLabel").toUpperCase()}
                                />
                                <div className="clinician-filter">
                                    <CheckedListControl
                                        DataSource={this.props.Model.get("CliniciansFiltered")}
                                        Operation={LocalOperations.Portfolio.MyNotes_OnSettingsContainerCheckboxChange}
                                        sort
                                        limitTextWidth
                                        enableLazyRendering
                                    />
                                </div>
                            </td>
                            <td>
                                <CheckedListControl
                                    DataSource={this.props.Model.get("Status")}
                                    Operation={LocalOperations.Portfolio.MyNotes_OnSettingsContainerCheckboxChange}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div className="notes-settings-footer">
                    <SearchSettingsFooter
                        onClose={() => sessionStore.dispatch(LocalOperations.Portfolio.MyNotes_SearchSettings_CancelClick)}
                        onOk={() => sessionStore.dispatch(LocalOperations.Portfolio.MyNotes_SearchSettings_OkClick)}
                        onColumnOrderingButtonClick={() => sessionStore.dispatch(LocalOperations.Portfolio.MyNotes_SearchSettings_ColumnOrderingPopup_Open)}
                        onResultsPerPageChange={value => sessionStore.dispatch(LocalOperations.Portfolio.MyNotes_SearchSettings_OnResultsPerPageChange, { value })}
                        selectedPageSizeOption={this.props.Model.get("SelectedPageSizeOption")}
                        pageSizeOptions={this.props.Model.get("PageSizeOptions").toArray()}
                    />
                </div>
            </div>
        );
    }

    public onCliniciansFilterTextChanged(value: string): void {
        sessionStore.dispatch(LocalOperations.Portfolio.MyNotes_SearchSettings_ClinicianFilterTextChanged, { value });
    }
}

export { NotesSettingsContainer };
